import { create } from 'zustand';

interface ChatState {
  unread: number;
  setUnread: (n: number) => void;
}

/** Счётчик непрочитанных общего чата — для меню и нижней панели. */
export const useChatStore = create<ChatState>((set) => ({
  unread: 0,
  setUnread: (unread) => set({ unread }),
}));
